import { activityMeasureSchema } from './activity-measure.js';
import { assessmentMeasurementConfigurationTagSchema, } from './assessment-measurement-configuration-tag.js';
import { z } from 'zod';
import { baseStudyEntityValidationSchema } from '../validation/index.js';
import { IllegalArgumentError } from 'faro-common-model';
import { StudyEntityType } from '../study-entity-type.js';
import { locationSchema } from '../biomedical-library-proxy.js';
import { uuidish } from '../../utils/uuidish.js';
import { nullishToUndefined } from '../../utils/nullishToUndefined.js';
import { nullishToEmptyArray } from '../../utils/nullishToEmptyArray.js';
/**
 * Default locationCode for the assessment measurement configuration
 */
export const defaultLocationCode = 'clinic';
/**
 * Maximum length of the label for the assessment measurement configuration
 */
export const maxAssessmentMeasurementConfigurationLabelLength = 250;
/**
 * @deprecated use {@link AnalysisLocation} instead.
 */
export var AnalysisLocations;
(function (AnalysisLocations) {
    AnalysisLocations["localLab"] = "Local Lab";
    AnalysisLocations["centralLab"] = "Central Lab";
})(AnalysisLocations || (AnalysisLocations = {}));
export const analysisLocationSchema = z.enum(['localLab', 'centralLab']);
export const assessmentMeasurementConfigurationSchema = z.object({
    ...baseStudyEntityValidationSchema.shape,
    entityType: z
        .literal(StudyEntityType.AssessmentMeasurementConfiguration)
        .default(StudyEntityType.AssessmentMeasurementConfiguration),
    label: z.string().max(maxAssessmentMeasurementConfigurationLabelLength),
    studyAssessmentMeasurementId: uuidish,
    selectedSystemCodes: z.array(z.string().nullish()).nullish().transform(nullishToEmptyArray),
    locations: z.array(locationSchema).nullish().transform(nullishToEmptyArray),
    costs: z.array(activityMeasureSchema).nullish().transform(nullishToEmptyArray),
    panelMemberIds: z.array(z.string()).nullish().transform(nullishToEmptyArray),
    instructions: z.string().nullish().transform(nullishToUndefined).optional(),
    isOptional: z.coerce.boolean(),
    biomarkerOfInterest: z.coerce.boolean(),
    analysisLocations: z.array(analysisLocationSchema).nullish().transform(nullishToEmptyArray),
    customTags: z.array(z.string()).nullish().transform(nullishToEmptyArray),
    autoCalculatedTags: z
        .array(assessmentMeasurementConfigurationTagSchema)
        .nullish()
        .transform(nullishToUndefined)
        .optional(),
    objectiveGroupTypeIds: z.array(z.string()).nullish().transform(nullishToEmptyArray),
});
export function toAssessmentMeasurementConfiguration(configuration) {
    const result = assessmentMeasurementConfigurationSchema.safeParse(configuration);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid AssessmentMeasurementConfiguration object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=assessment-measurement-configuration.js.map